var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcssr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.72 67.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #eb2027;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.81,0s.23,1.51-.51,2.53c-.88,1.2-1.38,1.57-2.22,2.68-.57.76-.46,1.38.83,1.57.43.06,1.38.18,1.85-.18.88-.7,2.12-3.32.05-6.59Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.22,7.42c-.68.78-2.58,3.23-2.58,3.23v7.94s1.85-1.48,2.86-2.4c.39-.35,1.02-.65,1.02-1.85v-7.11c0-.23.23-.89.23-.89,0,0-.65.08-1.52,1.08Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.07,18.13s-1.29,5.82-1.66,7.02c-.37,1.2-.18,2.58,1.02,4.25,1.2,1.66,3.23,3.51,3.23,5.91,0,0-2.58-.09-4.99-2.31-2.21-2.04-4.12-6.02-2.77-9.51,1.29-3.32,5.17-5.35,5.17-5.35Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.5,22.1s-1.38,6.55,2.12,10.71c3.89,4.61,9.27,7.03,7.66,11.17-1.29,3.32-4.99,4.8-4.99,4.8l-4.25-3.51s3.32-1.38,2.12-4.52c-.28-.72-.7-1.79-2.03-3.05-4.89-4.62-5.72-10.8-.65-15.6Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.33,38.81s-.8,4.2,2.12,8.03c2.68,3.51,4.97,4.15,5.63,8.31.74,4.62-1.48,7.2-2.4,8.31-.92,1.11-3.79,4.52-8.12,3.42,0,0,3.51-3.14,4.71-6.92.81-2.56.28-4.99-1.94-7.39-1.96-2.12-8.68-9.97,0-13.76Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.79,52.01s-.37-.28-.74-.55c-.74-.55-.92-1.57.18-1.85.39-.1,1.45-.33,1.85-.46.55-.18,1.29-.55,2.03-1.2.74-.65,5.35-6.74,9.6-5.91,0,0-3.32,2.03-5.08,4.25-2.64,3.34-2.31,5.08-2.31,6.74v11.17c0,1.66-1.48,3.05-3.05,3.05-2.4,0-3.88.09-3.88.09,0,0,1.38-1.57,1.38-2.95v-12.37Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcssr);
export default __webpack_public_path__ + "static/media/icssr.663f4c93f54c6292e04ccff9a71efd27.svg";
export { ForwardRef as ReactComponent };